// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nDA8","label":"styles_label__3UPaj"};